"use strict";

var _slicedToArray = require("/home/runner/work/nft-login-marketplace/nft-login-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.readBytes = exports.writeBytes = void 0;

var varint_1 = require("./varint");

var writeBytes = function writeBytes(bytes) {
  return Buffer.concat([varint_1.writeUInt32(bytes.length), bytes]);
};

exports.writeBytes = writeBytes;

var readBytes = function readBytes(buffer, offset) {
  var _varint_1$readUInt = varint_1.readUInt32(buffer, offset),
      _varint_1$readUInt2 = _slicedToArray(_varint_1$readUInt, 2),
      byteLength = _varint_1$readUInt2[0],
      keySize = _varint_1$readUInt2[1];

  return [buffer.subarray(offset + keySize, offset + keySize + byteLength), byteLength + keySize];
};

exports.readBytes = readBytes;